import React from 'react';
import { Grid, Typography } from '@mui/material';
import { gridSpacing } from 'store/constant';

export default function MachineInformation({ machineDetails }) {
  return (
    <Grid container spacing={gridSpacing} style={{ paddingTop: '30px' }}>
      <Grid item xs={12} className="machineModalView">
        <div style={{ border: '1px solid #6fd74b', borderRadius: '6px' }}>
          <div className="address_locationmain" style={{ background: '#6fd74b', mb: 2, padding: '10px 15px' }}>
            <Typography component="h4" variant="h3" sx={{ color: '#fff' }}>
              Machine Information
            </Typography>
          </div>
          <Grid container spacing={gridSpacing} style={{ paddingTop: '20px', paddingBottom: '20px' }}>
            <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: 0 }}>
              <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                    Machine Type :{' '}
                  </Typography>
                  <Typography variant="h4" component="sapn" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                    {machineDetails?.type || 'N.A.'}
                  </Typography>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: 0 }}>
              <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                    Nickname :{' '}
                  </Typography>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                    {machineDetails?.nickName || 'N.A.'}
                  </Typography>
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: 0 }}>
              <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                    Machine Model :{' '}
                  </Typography>
                  {machineDetails?.model ? (
                    <Typography
                      variant="h4"
                      // component={machineDetails?.model ? 'p' : 'span'}
                      component={'span'}
                      style={{ fontWeight: 'unset', paddingTop: 10 }}
                    >
                      {machineDetails?.model || 'N.A.'}
                    </Typography>
                  ) : (
                    'N.A.'
                  )}
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: 0 }}>
              <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                    Machine Software :{' '}
                  </Typography>
                  {machineDetails?.softwareVersions && Array.isArray(machineDetails?.softwareVersions) ? (
                    <Typography
                      variant="h4"
                      // component={machineDetails?.softwareVersions ? 'p' : 'span'}
                      component={'span'}
                      style={{ fontWeight: 'unset', paddingTop: 10 }}
                    >
                      {machineDetails?.softwareVersions && Array.isArray(machineDetails?.softwareVersions)
                        ? machineDetails?.softwareVersions.join(',')
                        : ''}
                    </Typography>
                  ) : (
                    'N.A.'
                  )}
                </div>
              </div>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4} sx={{ padding: 0 }}>
              <div style={{ border: '1px solid #fff', borderRadius: '6px', marginLeft: 15, marginRight: 15 }}>
                <div className="address_locationmain" style={{ margin: 5, padding: '5px', display: 'inherit' }}>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'bold' }}>
                    Bins :{' '}
                  </Typography>
                  <Typography variant="h4" component="span" style={{ fontWeight: 'unset', paddingTop: 10 }}>
                    {machineDetails?.bins || 'N.A.'}
                  </Typography>
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </Grid>
    </Grid>
  );
}
